import { render, staticRenderFns } from "./presalelist.vue?vue&type=template&id=c59b9708&"
import script from "./presalelist.vue?vue&type=script&lang=js&"
export * from "./presalelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports